/*
 * Copyright (c) 2019 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

import { setupOptions } from '../helper/setup-options.helper';
import { CoreErrorKey } from '../key/core-error.key';
import { CoreFormatterKey } from '../key/core-formatter.key';
import { ApplicationError } from '../model/application-error.model';
import { Formatter } from '../provider/formatter.provider';

export interface IndentFormatterOptions {
  indentation?: string;
  nullFormat?: string;
}

export class IndentFormatter implements Formatter {
  protected readonly options: IndentFormatterOptions;

  constructor(options?: IndentFormatterOptions) {
    this.options = IndentFormatter.setupOptions(options);
  }

  format(value: any | any[]): string {
    if (value === undefined || value === null) {
      return this.options.nullFormat === null ? '' : `\n${this.options.indentation}${this.options.nullFormat}`;
    }
    if (typeof value === 'string') {
      return `\n${this.options.indentation}${value.replace(/\n/g, `\n${this.options.indentation}`)}`;
    }
    if (!Array.isArray(value)) {
      value = [value];
    } else if (this.options.nullFormat === null) {
      value = value.filter((item) => item !== undefined && item !== null);
    }
    return value
      .map((item) => {
        if (item === undefined || item === null) {
          item = this.options.nullFormat;
        } else if (typeof item !== 'string') {
          item = JSON.stringify(item);
        }
        return `\n${this.options.indentation}${item.replace(/\n/g, `\n${this.options.indentation}`)}`;
      })
      .join('');
  }

  parse(value: string): any {
    throw new ApplicationError({
      key: CoreErrorKey.NOT_SUPPORTED,
      arguments: { key: CoreFormatterKey.INDENT, operation: 'parse' }
    });
  }

  clone(options: IndentFormatterOptions): IndentFormatter {
    return new IndentFormatter(Object.assign({}, this.options, options));
  }

  static setupOptions(options: IndentFormatterOptions): IndentFormatterOptions {
    try {
      return setupOptions({
        indentation: '  ',
        nullFormat: { type: 'string', default: null }
      }, options);
    } catch (error) {
      throw new ApplicationError({
        key: CoreErrorKey.FORMATTER_OPTIONS_INVALID,
        arguments: { formatterKey: CoreFormatterKey.INDENT, options, error },
        message: `Formatter options for '${CoreFormatterKey.INDENT}' invalid`
      });
    }
  }

}

